import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigBi } from 'pages/bi/types';

export function useQueryBiList() {
    const requestListagem = useRequestListagem();
    const { sort, page } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        page,
        url: '/config/configbiwrapper',
        columns: 'idConfigBi,dsConfigBi,cdPainelBi,vlAltura,vlAlturaMobile,nrSequencia,idTipoPainelBi,dsTipoPainelBi,fgAtivo',
        nested: true,
        sort: sort?.length ? sort : [{ direction: 'ASC', property: 'idConfigBi' }],
    };

    return useQuery<RequestListagem<ConfigBi[]>>([requestOptions], () => requestListagem(requestOptions).then((res) => res.data));
}
